module.exports = __webpack_public_path__ + "static/media/icon_environment.9f74e862.svg";